module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/julita-nowik-grodek-6688647b930252116c05f540b1a7d551.webp";